import parse from 'date-fns/parse';
import isValid from 'date-fns/isValid';
import format from 'date-fns/format';
import isBefore from 'date-fns/isBefore';

const FORMAT = 'MM-dd-yyyy';
const MIN_DATE_STRING = '01-01-1900';
const MIN_DATE = parse(MIN_DATE_STRING, FORMAT, new Date());

function isDateNotBeforeMinValidator(value) {
  const parsed = parse(value, FORMAT, new Date());

  if (!isValid(parsed)) {
    return false;
  }

  if (format(parsed, FORMAT) !== value) {
    return false;
  }

  if (isBefore(parsed, MIN_DATE)) {
    return false;
  }

  return true;
}

export default isDateNotBeforeMinValidator;



// WEBPACK FOOTER //
// ./src/utils/validations/isDateNotBeforeMinValidator.js